import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarPagos } from '../../actions/pagos';
import { buscarSucursales } from '../../actions/sucursales';
import { buscarMetodosTipo } from '../../actions/metodos';
import { buscarEmpleados } from '../../actions/empleados';
import { buscarEventos } from '../../actions/eventos';
import { editarBreadcrumb } from '../../actions/breadcrumb';
import { formatNumber } from '../../utils/generalFunctions';

import FiltrosPago from './FiltrosPago';

const formatNombre = (persona) => persona
    ? `${persona.nombre || ''} ${persona.apellido_paterno || ''} ${persona.apellido_materno || ''}`.trim()
    : '-';

const formatFecha = (fecha) => fecha
    ? new Date(fecha).toLocaleString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    : '-';

const filtrosVacios = {
    fecha_inicio: null,
    fecha_fin: null,
    responsable: null,
    vendedor: null,
    sucursal: null,
    evento: null,
    metodo: null
};

const Pagos = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { listado } = useSelector(state => state.pagos);

    const [filtrosModal, setFiltrosModal] = useState(false);
    const [filtros, setFiltros] = useState(filtrosVacios);

    useEffect(() => {
        dispatch(buscarPagos(filtrosVacios));
        dispatch(buscarSucursales());
        dispatch(buscarMetodosTipo(4));
        dispatch(buscarEmpleados());
        dispatch(buscarEventos(false));
        dispatch(editarBreadcrumb([
            { nombre: 'Pagos', path: '/pagos', activo: true }
        ]));
    }, []);

    const handleAplicarFiltros = (nuevosFiltros) => {
        setFiltros(nuevosFiltros);
        dispatch(buscarPagos(nuevosFiltros));
    };

    const filtrosActivos = [
        filtros.fecha_inicio,
        filtros.fecha_fin,
        filtros.responsable,
        filtros.vendedor,
        filtros.sucursal,
        filtros.evento,
        filtros.metodo
    ].filter(Boolean).length;

    const columns = [
        {
            name: 'Responsable',
            sortable: true,
            selector: row => formatNombre(row.responsable),
            grow: 2
        },
        {
            name: 'Vendedor',
            sortable: true,
            selector: row => formatNombre(row.vendedor),
            grow: 2
        },
        {
            name: 'Sucursal',
            sortable: true,
            selector: row => row.sucursal?.nombre || '-',
            grow: 1.5
        },
        {
            name: 'Evento',
            sortable: true,
            selector: row => row.evento?.nombre || '-',
            grow: 1.5
        },
        {
            name: 'Método',
            sortable: true,
            selector: row => row.metodo?.nombre || '-'
        },
        {
            name: 'Ventas amb.',
            sortable: true,
            selector: row => row.vueltas?.length ?? '-'
        },
        {
            name: 'Total',
            sortable: true,
            selector: row => row.total != null ? formatNumber(row.total, 2, '$', '') : '-'
        },
        {
            name: 'Fecha',
            sortable: true,
            grow: 1.5,
            selector: row => formatFecha(row.fecha)
        },
        {
            name: 'Acciones',
            cell: row => (
                <Link className="btn btn-sm btn-info" to={`/pagos/informacion/${row._id}`}>
                    <i className="fas fa-eye"></i>
                </Link>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-4 d-flex justify-content-between align-items-center">
                <h4 className="mb-0">Pagos de ventas ambulantes</h4>
                <button className="btn btn-secondary position-relative" onClick={() => setFiltrosModal(true)}>
                    <i className="fas fa-filter me-1"></i> Filtros
                    {filtrosActivos > 0 && (
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                            {filtrosActivos}
                        </span>
                    )}
                </button>
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay pagos registrados"
                />
            </div>

            <FiltrosPago
                show={filtrosModal}
                handleCerrar={() => setFiltrosModal(false)}
                filtros={filtros}
                handleAplicar={handleAplicarFiltros}
            />
        </div>
    );
};

export default Pagos;
